import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { BuildingIcon, BanknoteIcon, AlertCircleIcon, ActivityIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const lpuRevenueData = [{
  month: 'Jan',
  billed: 28000000,
  collected: 26500000
}, {
  month: 'Feb',
  billed: 29500000,
  collected: 27800000
}, {
  month: 'Mar',
  billed: 31000000,
  collected: 29000000
}, {
  month: 'Apr',
  billed: 30500000,
  collected: 28500000
}, {
  month: 'May',
  billed: 32000000,
  collected: 30500000
}, {
  month: 'Jun',
  billed: 34000000,
  collected: 31000000
}];
export function LpuRevenue() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-1400">
      {/* Header */}
      <div className="mb-8" data-id="element-1401">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1402">
          Large Power User Revenue
        </h1>
        <p className="text-gray-500" data-id="element-1403">
          Monitor billing, collections, and outstanding debt for large power
          user accounts.
        </p>
      </div>

      <div className="space-y-8" data-id="element-1404">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1405">
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1406">
            <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-1407">
              <BuildingIcon className="w-5 h-5" data-id="element-1408" />
            </div>
            <div data-id="element-1409">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1410">
                YTD Billed Demand
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1411">
                {formatZAR(185000000)}
              </p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1412">
            <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1413">
              <BanknoteIcon className="w-5 h-5" data-id="element-1414" />
            </div>
            <div data-id="element-1415">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1416">
                YTD Collected
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1417">
                {formatZAR(173300000)}
              </p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1418">
            <div className="p-3 bg-red-50 text-red-600 rounded-none" data-id="element-1419">
              <AlertCircleIcon className="w-5 h-5" data-id="element-1420" />
            </div>
            <div data-id="element-1421">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1422">
                Outstanding Debt
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1423">
                {formatZAR(11700000)}
              </p>
            </div>
          </div>
          <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1424">
            <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-1425">
              <ActivityIcon className="w-5 h-5" data-id="element-1426" />
            </div>
            <div data-id="element-1427">
              <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1428">
                Collection Rate
              </p>
              <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1429">93.6%</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200" data-id="element-1430">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1431">
            Billed vs Collected (Last 6 Months)
          </h2>
          <div className="h-80" data-id="element-1432">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1433">
              <BarChart data={lpuRevenueData} margin={{
              top: 10,
              right: 10,
              left: 20,
              bottom: 0
            }} data-id="element-1434">

                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1435" />

                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} dy={10} data-id="element-1436" />

                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} tickFormatter={val => `R${(val / 1000000).toFixed(0)}M`} data-id="element-1437" />

                <Tooltip formatter={(value: number) => [formatZAR(value), '']} contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} cursor={{
                fill: '#f3f4f6'
              }} data-id="element-1438" />

                <Legend verticalAlign="top" height={36} data-id="element-1439" />
                <Bar dataKey="billed" name="Billed Amount" fill="#9AADCC" radius={[0, 0, 0, 0]} data-id="element-1440" />

                <Bar dataKey="collected" name="Collected Amount" fill="#0D4F5C" radius={[0, 0, 0, 0]} data-id="element-1441" />

              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}